export const MB_PER_SECOND = 400000; // this should be a working number -- I got this by 36MB divided by 90 because it was taking a minute and a half to upload 36MB
export const THRESHOLD = 5;
